export default __webpack_public_path__ + "static/media/home-preview-branding.6adf57f2.jpg";